/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popover } from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Plus } from 'lucide-react';
import { STYLED_SELECT_CLASS, STYLED_SELECT_STYLE } from '../../../utils/styledSelect';

function AddModal({
  viewerType,
  viewers,
  onSaved,
}) {
  const [modalAnchorEl, setModalAnchorEl] = useState(null);
  const openModal = Boolean(modalAnchorEl);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [access, setAccess] = useState(0);

  const label = viewerType === 2 ? 'Member' : 'Team';

  const handleViewerChanged = (event) => {
    const selectedValue = event.target.value;
    const index = viewers.findIndex((viewer) => viewer.name === selectedValue);
    setSelectedIndex(index + 1);
  };

  const handleAccessChanged = (event) => {
    const selectedValue = event.target.value;
    setAccess(selectedValue === 'Full Access' ? 1 : 2);
  };

  const close = () => {
    setModalAnchorEl(null);
    setSelectedIndex(0);
    setAccess(0);
  };

  return (
    <>
      <button
        type="button"
        onClick={(e) => setModalAnchorEl(e.currentTarget)}
        className="inline-flex items-center gap-1.5 box-border h-9 px-3 rounded-[8px] text-sm font-semibold text-white bg-[#53A551] hover:bg-[#458a44] transition"
      >
        <Plus size={15} />
        {`Add ${label}`}
      </button>
      <Popover
        open={openModal}
        anchorEl={modalAnchorEl}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ '& .MuiPaper-root': { borderRadius: '12px', border: '1px solid #e0e1e6', boxShadow: '0 10px 15px -3px rgba(14,30,64,0.1)', marginTop: '4px' } }}
      >
        <div className="p-4" style={{ width: 300, fontFamily: 'Inter, sans-serif' }}>
          <span className="block text-sm font-semibold text-ink-900 mb-3">{`Add New ${label}`}</span>

          <span className="block text-xs font-medium text-ink-700 mb-1.5">{label}</span>
          <select defaultValue="" onChange={handleViewerChanged} className={`${STYLED_SELECT_CLASS} w-full`} style={STYLED_SELECT_STYLE}>
            <option value="" disabled>Required</option>
            {viewers && viewers.map((viewer) => <option key={viewer.id} value={viewer.name}>{viewer.name}</option>)}
          </select>

          <span className="block text-xs font-medium text-ink-700 mb-1.5 mt-3">Access Level</span>
          <select defaultValue="" onChange={handleAccessChanged} className={`${STYLED_SELECT_CLASS} w-full`} style={STYLED_SELECT_STYLE}>
            <option value="" disabled>Required</option>
            <option value="Full Access">Full Access</option>
            <option value="Limited Access">Limited Access</option>
          </select>

          <div className="flex justify-end mt-4">
            <button
              type="button"
              disabled={!selectedIndex || !access}
              onClick={() => {
                if (!selectedIndex || !access) return;
                onSaved(viewers[selectedIndex - 1].id, viewerType, access - 1);
                close();
              }}
              className="inline-flex items-center justify-center box-border h-9 px-5 rounded-[8px] text-sm font-semibold text-white bg-[#53A551] hover:bg-[#458a44] disabled:opacity-40 disabled:cursor-not-allowed transition"
            >
              Save
            </button>
          </div>
        </div>
      </Popover>
    </>
  );
}

AddModal.propTypes = {
  viewerType: PropTypes.number.isRequired,
  viewers: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  })),
  onSaved: PropTypes.func.isRequired,
};

AddModal.defaultProps = {
  viewers: [],
};

export default AddModal;
